import React, { useEffect, useState } from 'react'
import { Select, message as $message } from 'antd'

import { getChannelBindSalesmanList } from '@/services/docking'
import styles from './index.less'

const DockingSelect = ({ name, form, loading, ...restProps }) => {
    const [list, setList] = useState([])

    const init = async () => {
        try {
            const { success, data, message } = await getChannelBindSalesmanList()
            if (success) {
                const options = (data || []).map(v => ({
                    dockingPeople: v.userName,
                    dockingPeopleName: v.userName
                }))

                const newList = [{ dockingPeople: '0', dockingPeopleName: '无运营' }, ...options]

                setList(newList)
            } else {
                $message.error(message)
            }
        } catch (error) {
            console.error('catchError', error)
        }
    }

    useEffect(() => {
        init()
    }, [])

    // 初始化方法
    form?.setLocalData &&
        form.setLocalData(name, {
            init,
            options: list.map(v => ({ value: v.dockingPeople, label: v.dockingPeopleName }))
        })

    return (
        <Select
            showSearch
            className={styles.container}
            allowClear
            loading={loading}
            placeholder="请选择对接人"
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            {...restProps}
        >
            {list.map(item => (
                <Select.Option key={item.dockingPeople}>{item.dockingPeopleName}</Select.Option>
            ))}
        </Select>
    )
}

export default DockingSelect
